import { isCloudflareOriginErrorStatus, parseCloudflareErrorCode } from '@repo/config/errors';
import { errors } from 'rfc9457';
import { CloudflareError } from '../../httpClient/requestExecutor/cloudflare-error';

const WORKER_PATTERN = /exceeded resource limits/i;

function detectCloudflareReason(body: string): 'tunnel' | 'worker' {
  return WORKER_PATTERN.test(body) ? 'worker' : 'tunnel';
}

function extractDetail(raw: string, fallback: string): string {
  try {
    const parsed = JSON.parse(raw) as { detail?: string; title?: string };
    return parsed.detail ?? parsed.title ?? fallback;
  } catch {
    return raw || fallback;
  }
}

export async function throwVaultError(res: Response): Promise<never> {
  const raw = await res.text().catch(() => '');
  const cloudflareCode = parseCloudflareErrorCode(raw);

  if (isCloudflareOriginErrorStatus(res.status) || cloudflareCode !== null) {
    throw new CloudflareError({
      status: res.status,
      reason: detectCloudflareReason(raw),
      code: cloudflareCode ?? undefined,
    });
  }

  const detail = extractDetail(raw, res.statusText);
  if (res.status === 404) {
    throw errors.client.notFound(detail);
  }
  if (res.status === 400) {
    throw errors.client.badRequest(detail);
  }
  if (res.status === 401) {
    throw errors.client.authentication(detail);
  }
  throw errors.server.internal(detail);
}
